module.exports = __webpack_public_path__ + "static/media/voult-logo.42e42f58.svg";